import { render } from "./MenuEmpty.vue?vue&type=template&id=c081cda6"
import script from "./MenuEmpty.vue?vue&type=script&lang=js"
export * from "./MenuEmpty.vue?vue&type=script&lang=js"
script.render = render

export default script